// https://support.google.com/firebase/answer/7015592?hl=ja
export const FIREBASE_CONFIG_DEVELOPMENT = {
  apiKey: "AIzaSyARRgyyJrBFEYLEs7RkFTnab9WAkDHUGuQ",
  authDomain: "darkindependants-dev.firebaseapp.com",
  databaseURL: "https://darkindependants-dev.firebaseio.com",
  projectId: "darkindependants-dev",
  storageBucket: "darkindependants-dev.appspot.com",
  messagingSenderId: "494268042034",
  appId: "1:494268042034:web:3955021697dcfb63c7652b",
  measurementId: "G-G53H2XPKXB"
};

export const FIREBASE_CONFIG_PRODUCTION = {
  apiKey: "AIzaSyBNH5n94Ih0JhVJ_ZmDt8jgVtYk-JkwdUg",
  authDomain: "darkindependants.firebaseapp.com",
  databaseURL: "https://darkindependants.firebaseio.com",
  projectId: "darkindependants",
  storageBucket: "darkindependants.appspot.com",
  messagingSenderId: "948213857736",
  appId: "1:948213857736:web:2ab29c944f8fe645f854fd",
  measurementId: "G-JCTR9YR0VQ"
};

const PRODUCTION_HOST_NAME = "darkindependants.web.app"

const isProduction = (location.hostname == PRODUCTION_HOST_NAME);

export const FIREBASE_CONFIG = isProduction ? FIREBASE_CONFIG_PRODUCTION : FIREBASE_CONFIG_DEVELOPMENT;
export const GOOGLE_MAP_KEY = FIREBASE_CONFIG.apiKey
